import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=35d176b0&scoped=true"
import script from "./Invitation.vue?vue&type=script&lang=js"
export * from "./Invitation.vue?vue&type=script&lang=js"
import style0 from "./Invitation.vue?vue&type=style&index=0&id=35d176b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d176b0",
  null
  
)

export default component.exports